import { render, staticRenderFns } from "./campaignsCard.vue?vue&type=template&id=4a5184ff&scoped=true"
import script from "./campaignsCard.vue?vue&type=script&lang=js"
export * from "./campaignsCard.vue?vue&type=script&lang=js"
import style0 from "./campaignsCard.vue?vue&type=style&index=0&id=4a5184ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5184ff",
  null
  
)

export default component.exports